export { MediaPage as Media } from './Media';
